<xpo-card>
  <xpo-card-header>
    <xpo-card-title class="mile-calc-title">{{ title }}</xpo-card-title>
  </xpo-card-header>
  <xpo-card-content>
    <div class="mile-calc-content">
      <form [formGroup]="formGroup">
        <div class="col-12">
          <mat-form-field floatLabel="always">
            <mat-label>Country</mat-label>
            <mat-select formControlName="countryCd" required>
              <mat-option *ngFor="let country of countries" [value]="country.value">
                {{ country.display }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="formGroup?.get('countryCd').hasError('required')">Field required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-12">
          <mat-form-field floatLabel="always">
            <mat-label>Input Method</mat-label>
            <mat-select formControlName="inputMethod" required placeholder="Select an Input Method">
              <mat-option *ngFor="let type of destTypes" [value]="type.value">
                {{ type.display }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="formGroup?.get('inputMethod').hasError('required')">Field required</mat-error>
          </mat-form-field>
        </div>
        <ng-container *ngIf="displayZipOnly">
          <div class="col-12">
            <mat-form-field floatLabel="always">
              <mat-label>Postal Code</mat-label>
              <input
                matInput
                formControlName="zipCd"
                required
                style="text-transform: uppercase"
                pattern="[a-zA-Z0-9]+"
              />
              <mat-error *ngIf="formGroup?.get('zipCd').hasError('required')">Field required</mat-error>
            </mat-form-field>
          </div>
        </ng-container>
        <ng-container *ngIf="displayStateCity">
          <app-state-city [countryCd]="formGroup.get('countryCd').value" (onSelectZipCode)="onSelectZipCode($event)"></app-state-city>
        </ng-container>
      </form>
    </div>
  </xpo-card-content>
</xpo-card>
